import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CiMenuFries } from "react-icons/ci";
import { motion } from "framer-motion";
import productLogo from "../../assets/images/appLogo.png";
import ConatctUs from "pages/contactus/ContactUs";
import { useTranslation } from "react-i18next";
import LanguageSelector from "components/LanguageSelector";
import { TfiClose } from "react-icons/tfi";
import { useAppState } from "context/AppContext ";

const Navbar = () => {
  const {
    handleCloseDropdown,
    toggledropdown,
    isDropdownOpen,
    dropdownContent,
    activeLink,
    setActiveLink,
    setIsDropdownOpen,
    setDropdownContent,
    navLinks,
  } = useAppState();
  const location = useLocation();
  const { t } = useTranslation();

  return (
    <>
      <nav
        className={`h-[64px] sticky top-0 z-50 transition-colors duration-300 bg-white shadow-md `}
      >
        <motion.div
          className="w-full mx-auto h-[100%] flex items-center justify-between p-4"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Link
            to="/"
            className="flex items-center"
            onClick={handleCloseDropdown}
          >
            <motion.div
              className="w-[100px] h-[50px] md:mt-7 sm:w-[169px] lg:w-[169px] sm:h-[60px] lg:h-[60px]"
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.3 }}
            >
              <img
                src={productLogo}
                alt="Logo"
                className="h-[100%] w-[100%] object-contain"
              />
            </motion.div>
          </Link>
          <div className="hidden md:flex items-center space-x-6 2xl:space-x-10">
            {navLinks.map((link, index) => (
              <motion.div
                key={index}
                whileHover={{ scale: 1 }}
                transition={{ duration: 0.3 }}
              >
                <motion.div
                  key={index}
                  className="relative"
                  initial="rest"
                  animate={
                    location.pathname === link.to &&
                      dropdownContent !== "contactus"
                      ? "hover"
                      : "rest"
                  }
                  whileHover="hover"
                >
                  <Link
                    to={link.to}
                    className={`relative text-[14px] sm:text-[16px] 2xl:text-[18px] leading-[16.94px] ${location.pathname === link.to &&
                      dropdownContent !== "contactus"
                      ? "text-secondary-main font-medium"
                      : ""
                      }`}
                    onClick={() => {
                      setActiveLink(link.to);
                      setIsDropdownOpen(false);
                      setDropdownContent(null);
                    }}
                  >
                    {link.name}
                    <motion.div
                      className="absolute left-0 -bottom-1 h-[2px] bg-secondary-main origin-left rounded-md"
                      variants={{
                        rest: { width: 0, opacity: 0 },
                        hover: {
                          width: "100%",
                          opacity: 1,
                          transition: { duration: 0.3, ease: "easeOut" },
                        },
                      }}
                    />
                  </Link>
                </motion.div>
              </motion.div>
            ))}
            <motion.div
              className="relative"
              initial="rest"
              animate={activeLink === "/contactus" ? "hover" : "rest"}
              whileHover="hover"
            >
              <Link
                className={`relative text-[14px] sm:text-[16px] 2xl:text-[18px] leading-[16.94px] ${activeLink === "/contactus"
                  ? "text-secondary-main font-medium"
                  : ""
                  }`}
                onClick={() => {
                  setActiveLink("/contactus");
                  toggledropdown("contactus");
                }}
              >
                {t("navbar.contactUs")}
                <motion.div
                  className="absolute left-0 -bottom-1 h-[2px] bg-secondary-main origin-left rounded-md"
                  variants={{
                    rest: { width: 0, opacity: 0 },
                    hover: {
                      width: "100%",
                      opacity: 1,
                      transition: { duration: 0.3, ease: "easeOut" },
                    },
                  }}
                />
              </Link>
            </motion.div>



            <motion.div
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.97 }}
              transition={{ duration: 0.2 }}
            >
              <a
                href="/login"
                className="
      inline-flex items-center justify-center
      px-6 py-2.5
      rounded-full
      border border-primary-main
      text-primary-main
      font-medium
      text-base
      transition-all duration-300
      hover:bg-primary-main
      hover:text-white
      hover:shadow-lg
      focus:outline-none
      focus:ring-4
      focus:ring-primary-main/20
    "
              >
                {t("common.login")}
              </a>
            </motion.div>

            <motion.div
              whileHover={{ scale: 1.1 }}
              transition={{ duration: 0.3 }}
            >
              <LanguageSelector />
            </motion.div>
          </div>
          <div className="md:hidden flex items-center gap-3">
            <LanguageSelector />
            <div className="min-w-[60px] min-h-[60px] flex items-center justify-center">
              {!isDropdownOpen ? (
                <button
                  className="block md:hidden text-[20px] p-2 focus:outline-none"
                  onClick={() => toggledropdown("menu")}
                >
                  <CiMenuFries size={"2rem"} style={{ color: "black" }} />
                </button>
              ) : (
                <button
                  className="block md:hidden text-[20px] p-2 focus:outline-none"
                  onClick={handleCloseDropdown}
                >
                  <TfiClose
                    className={"text-black text-[24px] md:text-[30px]"}
                  />
                </button>
              )}
            </div>
          </div>
        </motion.div>
      </nav>

      <motion.div
        initial={{ y: "-100%", opacity: 0 }}
        animate={{
          y: isDropdownOpen ? 0 : "-100%",
          opacity: isDropdownOpen ? 1 : 0,
        }}
        transition={{ duration: 0.5 }}
        className={`fixed top-[64px] left-0 z-40 w-full h-auto bg-paper-main shadow-lg rounded-br-2xl rounded-bl-2xl py-2 sm:py-10`}
      >
        <div className="absolute top-3 right-4 flex items-center gap-3">
          <button
            className={`hidden ${dropdownContent === "contactus" ? "md:block" : "md:hidden"
              } text-[20px] p-2 focus:outline-none`}
            onClick={handleCloseDropdown}
          >
            <TfiClose className={"text-black text-[24px] md:text-[30px]"} />
          </button>
        </div>

        <div className="w-full h-[90vh] overflow-auto sm:h-[500px] flex justify-center">
          {dropdownContent === "contactus" ? (
            <div className="w-full lg:w-1/2 ">
              <ConatctUs setIsDropdownOpen={setIsDropdownOpen} />
            </div>
          ) : (
            <motion.div
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="flex flex-col items-center space-y-6"
            >
              {navLinks.map((link, index) => (
                <motion.div
                  key={index}
                  whileHover={{ scale: 1.1 }}
                  transition={{ duration: 0.3 }}
                >
                  <Link
                    to={link.to}
                    className={`text-[14px] sm:text-[16px] 2xl:text-[18px] leading-[16.94px] ${location.pathname === link.to ? "text-secondary-main" : ""
                      }`}
                    onClick={() => {
                      setActiveLink(link.to);
                      setIsDropdownOpen(false);
                    }}
                  >
                    {link.name}
                  </Link>
                </motion.div>
              ))}
              <motion.div
                whileHover={{ scale: 1.1 }}
                transition={{ duration: 0.3 }}
              >
                <Link
                  className={`text-[14px] sm:text-[16px] 2xl:text-[18px] leading-[16.94px] ${activeLink === "/contactus" ? "text-secondary-main" : ""
                    }`}
                  onClick={() => {
                    setActiveLink("/contactus");
                    toggledropdown("contactus");
                  }}
                >
                  {t("navbar.contactUs")}
                </Link>
              </motion.div>
            </motion.div>
          )}
        </div>
      </motion.div>

      {isDropdownOpen && (
        <div
          className="fixed -inset-8 bg-black bg-opacity-50 z-10"
          onClick={handleCloseDropdown}
        ></div>
      )}
    </>
  );
};

export default Navbar;
